import { styled } from '@mui/material/styles';
import HelpIcon from '@mui/icons-material/Help';

const HelpTooltipIcon = styled(HelpIcon)(({ theme }) => ({
    color:'#9B9B9B' ,
    backgroundColor: '#FFFFFF',
    width: '1rem',
}));


export default HelpTooltipIcon;
